export const isSSG = () => process.env && process.env.NEXT_PHASE === 'phase-production-build'
